/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamQuestionLibrary200,
  GetApiV1ExamQuestionLibrary400,
  GetApiV1ExamQuestionLibrary401,
  GetApiV1ExamQuestionLibrary500,
  GetApiV1ExamQuestionLibraryQueryParams,
  GetApiV1ExamQuestionLibraryQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamQuestionLibrary.ts";
import { eExamItemStatusSchema } from "../eExamItemStatusSchema.ts";
import { questionLibraryItemRepositoryResponsePaginatedResponseSchema } from "../questionLibraryItemRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1ExamQuestionLibraryQueryParamsSchema = z
  .object({
    StartDate: z.optional(z.string()),
    EndDate: z.optional(z.string()),
    LabelSearch: z.optional(z.string()),
    Status: z.optional(
      z
        .lazy(() => eExamItemStatusSchema)
        .describe("1 = Pending | 2 = Approved | 3 = Rejected | "),
    ),
    CulturesInfo: z.optional(z.string()),
    DisciplineId: z.optional(z.coerce.number().int()),
    PersonId: z.optional(z.coerce.number().int()),
    CompanyId: z.optional(z.coerce.number().int()),
    ComponentType: z.optional(z.coerce.number().int()),
    Active: z.optional(z.boolean()),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
    SortField: z.optional(z.string()),
    SortDirection: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamQuestionLibraryQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamQuestionLibrary200Schema = z.lazy(
  () => questionLibraryItemRepositoryResponsePaginatedResponseSchema,
) as unknown as ToZod<GetApiV1ExamQuestionLibrary200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamQuestionLibrary400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamQuestionLibrary400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamQuestionLibrary401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamQuestionLibrary401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamQuestionLibrary500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamQuestionLibrary500>;

export const getApiV1ExamQuestionLibraryQueryResponseSchema = z.lazy(
  () => getApiV1ExamQuestionLibrary200Schema,
) as unknown as ToZod<GetApiV1ExamQuestionLibraryQueryResponse>;
